function isValidISODate(dateString: string): boolean {
    // 1. Validar formato estricto YYYY-MM-DD
    const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!isoRegex.test(dateString)) return false;

    // 2. Parsear componentes
    const [year, month, day] = dateString.split('-').map(Number);

    // 3. Crear fecha en UTC (evita problemas de timezone)
    const date = new Date(Date.UTC(year, month - 1, day));

    // 4. Verificar que la fecha reconstruida coincide exactamente
    return (
        date.getUTCFullYear() === year &&
        date.getUTCMonth() === month - 1 &&
        date.getUTCDate() === day
    );
}

export default isValidISODate;
